import React from "react";
import { FormInstance } from "antd/lib";
import { IntelligenceFormFieldsEnum } from "../../enum";
import { useChartWrapperContext } from "@src/contexts/ab-testing/chart-wrapper-context";
import { useApiUrl } from "@refinedev/core";
import { useBlockNavigateUnSave } from "@src/hooks/use-block-navigate-unsave";
import { useSmartCustomMutation } from "@src/hooks/use-smart-custom-mutation";
import { LoadingComponent } from "@src/components/loading-custom";
import { ISLoadingTips, LoadingMessage } from "@src/constant/loading-message";

export const SweetVisEda: React.FC<{
    form: FormInstance;
    setIsEdaLoading: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ form, setIsEdaLoading }) => {
    const { setWarnWhen } = useBlockNavigateUnSave();
    const [signedUrl, setSignedUrl] = React.useState(null);
    const { renderedQueries } = useChartWrapperContext();
    const { mutateAsync, isLoading } = useSmartCustomMutation();

    const apiUrl = useApiUrl("eda-report");

    React.useEffect(() => {
        setIsEdaLoading(isLoading);
    }, [isLoading]);

    React.useEffect(() => {
        const productCode = form.getFieldValue(IntelligenceFormFieldsEnum.PRODUCT_CODE);
        mutateAsync({
            method: "post",
            url: apiUrl + "/eda/report",
            values: {
                sql: renderedQueries["intelligence-search"],
            },
            successNotification: false,
            config: {
                headers: {
                    "product-code": productCode,
                },
            },
        })
            .then((data) => {
                if (data.signed_url) {
                    setSignedUrl(data.signed_url);
                    setWarnWhen(true);
                }
            })
            .catch((err) => {
                setSignedUrl(null);
            });
    }, [JSON.stringify(renderedQueries)]);

    if (isLoading) {
        return (
            <div className="w-full h-[70vh] flex justify-center items-center">
                <LoadingComponent message={LoadingMessage} tips={ISLoadingTips} />
            </div>
        );
    }
    return (
        <div className="w-[100vw] h-[70vh] overflow-hidden">
            {signedUrl && (
                <iframe
                    src={signedUrl}
                    width="100%"
                    height="100%"
                    title="Content viewer"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            )}
        </div>
    );
};
